// File#: _1_expandable-table
// Usage: codyhouse.co/license
(function() {
  var ExTable = function(element) {
    this.element = element;
    this.rows = this.element.getElementsByClassName('js-ex-table__body')[0].getElementsByTagName('tr');
    this.labels = this.element.getElementsByClassName('js-ex-table__label');
    initTable(this);
  };

  function initTable(table) {
    // init aria-expanded attributes for 'More' buttons
    var moreButtons = table.element.getElementsByClassName('js-ex-table__btn');
    for(var i = 0; i < moreButtons.length; i++) {
      var rowExpanded = moreButtons[i].closest('.ex-table__row--show-more-content') ? true : false;
      moreButtons[i].setAttribute('aria-expanded', rowExpanded);
    }

    // detect click on more Button - toggle additional table content
    table.element.addEventListener('click', function(event){
      var button = event.target.closest('.js-ex-table__btn');
      if(!button) return;
      var tableRow = button.parentNode.parentNode,
          showMore = !tableRow.classList.contains('ex-table__row--show-more-content');

      tableRow.classList.toggle('ex-table__row--show-more-content', showMore);
      button.setAttribute('aria-expanded', showMore);
      if(!showMore) resetRowStyle(table, tableRow, showMore);
      resetTableStyle(table);
    });
  };

  function resetTableStyle(table) { // update table style according to layout
    for(var i = 0; i < table.rows.length; i++) {
      if( table.rows[i].classList.contains('ex-table__row--show-more-content')) {
        resetRowStyle(table, table.rows[i], true);
      }
    }
  };

  function resetRowStyle(table, row, showBool) {
    var content = row.getElementsByClassName('js-ex-table__more-content');
    if(content.length== 0 ) return;
    console.log(table.labels[0].offsetWidth)
    if(table.labels[0].offsetWidth <= 0) {
      resetExpandedRowStyle(table, row, content[0], showBool);
    } else {
      resetCompressedRowStyle(row, content[0]);
    }
  };

  function resetExpandedRowStyle(table, row, content, showBool) {
    // row style applied when table layout is expanded
    if(showBool) {
      var offsetHeight = content.offsetHeight,
          cells = row.children;
      for(var i = 0; i < cells.length; i++) {
        cells[i].setAttribute('style', 'border-bottom-width:'+offsetHeight+'px;');
      }
      content.setAttribute('style', 'top: '+parseFloat(row.offsetHeight + row.offsetTop - offsetHeight)+'px;');
    } else {
      resetCompressedRowStyle(row, content);
    }
  };

  function resetCompressedRowStyle(row, content) {
    // row style applied when table layout is compressed
    content.removeAttribute('style');
    var cells = row.children;
    for(var i = 0; i < cells.length; i++) {
      cells[i].removeAttribute('style');
    }
  };

  var tables = document.getElementsByClassName('js-ex-table');
  if( tables.length > 0 ) {
    for( var i = 0; i < tables.length; i++) {
      new ExTable(tables[i]);
    }
  }
}());